import * as React from 'react';
import { Link } from '../../../../../../../../common/Link';
import { fairPlayIcon } from '../../../icons';
import { ErrorWrapper } from '../../ErrorWrapper';

export interface IFatalErrorProps {
  onClickRetry(): void;
}

export const FatalError = ({ onClickRetry }: IFatalErrorProps) => {
  return (
    <ErrorWrapper icon={fairPlayIcon}>
      Ошибка на&nbsp;сервере. <Link onClick={onClickRetry}>Попробовать&nbsp;ещё&nbsp;раз</Link>
    </ErrorWrapper>
  );
};
